export default __webpack_public_path__ + "static/media/bp_low.f5850efe.svg";